module.exports = __webpack_public_path__ + "img/money-approve.5194b69d.svg";